"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _elDragDialog = _interopRequireDefault(require("@/directive/el-drag-dialog"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// base on element-ui
var _default2 = exports.default = {
  name: 'Model',
  directives: {
    elDragDialog: _elDragDialog.default
  },
  props: {
    // ----- elment-ui dialog 原始属性 -----
    isShow: {
      type: Boolean,
      default: false
    },
    dragFlag: {
      type: Boolean,
      default: true
    },
    dialogStatus: {
      // title
      type: String,
      default: 'create'
    },
    modal: {
      type: Boolean,
      default: true
    },
    modalAppendToBody: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    closeOnPressEscape: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '500px'
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: ''
    },
    top: {
      type: String,
      default: '15vh'
    },
    beforeClose: {
      type: Function,
      default: function _default() {}
    },
    beforeCancel: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    center: {
      type: Boolean,
      default: true
    },
    destroyOnClose: {
      type: Boolean,
      default: true
    },
    // ----- elment-ui dialog 原始属性 -----

    isOnlyConfirm: {
      // 底部只展示一个按钮 alert模式
      type: Boolean,
      default: false
    },
    isHideFooter: {
      // 不展示底部按钮
      type: Boolean,
      default: false
    },
    // ----  关闭按钮时的数据比对 -----
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    initForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    array: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    initArray: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // ----  关闭按钮时的数据比对 -----

    confirmBtnText: {
      // 确认按钮的文本
      type: String,
      default: 'confirm'
    },
    // 自定义确认按钮
    customConfirmText: {
      type: String,
      default: ''
    },
    cancelBtnText: {
      // 取消按钮的文本
      type: String,
      default: 'cancel'
    },
    // 自定义取消按钮
    customCancelText: {
      type: String,
      default: ''
    },
    saveItem: {
      // confirm btn callback
      type: Function,
      default: function _default() {}
    },
    clearForm: {
      // 清除文本 callback
      type: Function,
      default: function _default() {}
    },
    closeModel: {
      // cancel btn callback
      type: Function,
      default: function _default() {}
    },
    // 自定义标题
    customTitle: {
      type: String,
      default: ''
    },
    isShowCustomTitleSlot: {
      type: Boolean,
      default: false
    },
    // 用于防重复触发、条件判定等
    canSubmit: {
      type: Boolean,
      default: true
    },
    // 是否高度自适应
    autoHeight: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      styleObject: {}
    };
  },
  computed: {
    isVisible: {
      get: function get() {
        return this.isShow;
      },
      set: function set(val) {
        this.$emit('update:isShow', val);
      }
    },
    dialogTitle: function dialogTitle() {
      // 优先自定义标题
      if (this.customTitle) {
        return this.customTitle;
      }
      var hasKey = this.$te("common.".concat(this.dialogStatus));
      if (hasKey) {
        return this.$t("common.".concat(this.dialogStatus));
      }
      return this.dialogStatus;
    },
    confirmButtonText: function confirmButtonText() {
      // 优先自定义
      if (this.customConfirmText) {
        return this.customConfirmText;
      }
      var hasKey = this.$te("common.".concat(this.confirmBtnText));
      if (hasKey) {
        return this.$t("common.".concat(this.confirmBtnText));
      }
      return this.confirmBtnText;
    },
    cancelButtonText: function cancelButtonText() {
      // 优先自定义
      if (this.customCancelText) {
        return this.customCancelText;
      }
      var hasKey = this.$te("common.".concat(this.cancelBtnText));
      if (hasKey) {
        return this.$t("common.".concat(this.cancelBtnText));
      }
      return this.cancelBtnText;
    }
  },
  mounted: function mounted() {},
  methods: {
    clickCloseBtn: function clickCloseBtn(done) {
      var _this = this;
      if (this.isOnlyConfirm || this.isHideFooter) {
        this.isVisible = false;
        return;
      }
      // console.log('close------', this.form.values[1].state, this.initForm.values[1].state)
      var isSame = (0, _index.compareObject)(this.form, this.initForm);
      var isSame1 = (0, _index.compareArray)(this.array, this.initArray);
      // console.log('isSame--isSame1-------', isSame, isSame1)

      if (isSame && isSame1) {
        this.isVisible = false;
      } else {
        this.$confirm(this.$t('common.confirm11')).then(function (_) {
          _this.isVisible = false;
          // done()
          _this.clearForm();
        }).catch(function (_) {});
      }
    },
    clickCancel: function clickCancel() {
      // 校验
      if (this.beforeCancel()) {
        this.clickCloseBtn();
      }
      // this.clearForm()
      // this.closeModel()
    },
    clickSave: function clickSave() {
      this.saveItem();
    },
    closeFunc: function closeFunc() {
      this.closeModel();
    }
  }
};